export enum BizType {
  MYDATA_CORP = 'MYDATA_CORP',
  MYDATA_PROVIDER = 'MYDATA_PROVIDER',
  SET4 = 'SET4',
  EDOC = 'EDOC',
  EPROOF = 'EPROOF'
}

export const BIZ_TYPE = {
  [BizType.MYDATA_CORP]: '마이데이터 통합인증 서비스',
  [BizType.MYDATA_PROVIDER]: '마이데이터제공자 서비스',
  [BizType.SET4]: '인증 서비스',
  [BizType.EDOC]: '전자문서 서비스',
  [BizType.EPROOF]: '모바일전자증명 서비스'
} as const;

export const BIZ_TIARA_TYPE = {
  [BizType.MYDATA_CORP]: '마이데이터',
  [BizType.MYDATA_PROVIDER]: '마이데이터',
  [BizType.SET4]: '인증',
  [BizType.EDOC]: '전자문서',
  [BizType.EPROOF]: '모바일전자증명'
} as const;

export const ALL_BIZ_TYPES = Object.values(BizType);
export const STATS_REPORT_BIZ_TYPES = [BizType.SET4, BizType.EDOC];

/** 서비스 정책 판별자를 만든다. bizType이 아직 없는 시점에도 그대로 호출할 수 있고, 통과하면 null이 좁혀진다 */
const bizTypeIn =
  (allowedBizTypes: BizType[]) =>
  (bizType: BizType | null): bizType is BizType =>
    !!bizType && allowedBizTypes.includes(bizType);

/** 지갑채널을 쓰지 않고 이용기관 채널만 사용하는 서비스 */
export const isPartnerChannelOnly = bizTypeIn([BizType.EDOC, BizType.EPROOF]);

/** 알림톡 이미지를 등록할 수 있는 서비스 */
export const isAlimTalkImageVisible = bizTypeIn([BizType.EDOC, BizType.EPROOF]);

/** 동일 사업자에 같은 기관명이 여러 개 존재할 수 있어 기관명 수정 시 함께 변경되는 서비스 */
export const isSvcNameShared = bizTypeIn([BizType.EDOC, BizType.EPROOF]);

/** 보안 정책상 IP를 파트너센터에서 직접 입력하지 않고 문의게시판으로 신청하는 서비스 */
export const isIpRegisterByInquiry = bizTypeIn([BizType.EDOC, BizType.EPROOF]);

/** 공인전자주소 등록 여부를 노출하는 서비스 */
export const isCEAVisible = bizTypeIn([BizType.EDOC, BizType.EPROOF]);

/** 계약 상품을 옵션 확인 레이어에서 선택하는 서비스 */
export const hasProductOption = bizTypeIn([BizType.EDOC, BizType.EPROOF]);

/** 이용기관 하위에 기관을 추가할 수 있는 서비스 */
export const isSvcAddable = bizTypeIn([BizType.SET4, BizType.EDOC, BizType.EPROOF]);
